// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"406108ff","312":"e3b7bc73","427":"0afcab22","457":"54dc53f2","629":"e3e47e7e"}[chunkId] + ".chunk.js";
};